import { render, staticRenderFns } from "./main-button-group.vue?vue&type=template&id=fcad8d54&scoped=true&"
import script from "./main-button-group.vue?vue&type=script&lang=js&"
export * from "./main-button-group.vue?vue&type=script&lang=js&"
import style0 from "./main-button-group.vue?vue&type=style&index=0&id=fcad8d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcad8d54",
  null
  
)

export default component.exports